<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form
        layout="inline"
        @submit="handleSearch"
        :autoFormCreate="
          (form) => {
            this.searchForm = form;
          }
        "
      >
        <a-row :gutter="48">
          <a-col span="5">
            <a-form-item label="调出门店" fieldDecoratorId="out_branch_id">
              <a-select placeholder="请选择" allowClear show-search option-filter-prop="children">
                <a-select-option v-for="item in branches" :key="item.id">{{
                  item.name
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col span="5">
            <a-form-item label="调入门店" fieldDecoratorId="branch_id">
              <a-select placeholder="请选择" allowClear show-search option-filter-prop="children">
                <a-select-option v-for="item in branches" :key="item.id">{{
                  item.name
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col span="5">
            <a-form-item label="状态" fieldDecoratorId="state">
              <a-select placeholder="请选择" allowClear>
                <a-select-option :key="0">全部</a-select-option>
                <a-select-option :key="3">处理中</a-select-option>
                <a-select-option :key="1">待发货</a-select-option>
                <a-select-option :key="2">在途中</a-select-option>
                <a-select-option :key="4">已入库</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col span="5">
            <a-form-item
              label="钉钉审批号"
              fieldDecoratorId="ding_talk_order_no"
            >
              <a-input placeholder="请输入钉钉审批号" />
            </a-form-item>
          </a-col>
          <a-col span="5">
            <a-form-item label="调拨单号" fieldDecoratorId="order_no">
              <a-input placeholder="请输入调拨单号" />
            </a-form-item>
          </a-col>
          <a-col span="2">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" htmlType="submit">查询</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <s-table ref="table" size="default" :columns="columns" :data="loadData">
      <template slot="state" slot-scope="text">
        {{ text | allocationFilter }}
      </template>
      <template slot="action" slot-scope="text, record">
        <a @click="handleView(record)">查看</a>
      </template>
    </s-table>
  </a-card>
</template>
<script>
import STable from "@/components/table/";
import { getSorderList } from "@/api/purchase";
// import { getAllocationRecord } from "@/api/stock";
import { getBranchList } from "@/api/branch";

export default {
  name: "StockList",
  components: {
    STable,
  },
  data() {
    return {
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      form: null,
      mdl: {},
      // 查询参数
      searchForm: null,
      queryParam: {},
      // 表头
      branches: [],
      columns: [
        {
          title: "调拨单号",
          dataIndex: "order_no",
        },
        {
          title: "钉钉审批号",
          dataIndex: "ding_talk_order_no",
        },
        {
          title: "调出门店",
          dataIndex: "out_branch_name",
        },

        {
          title: "调入门店",
          dataIndex: "branch_name",
        },
        {
          title: "调拨操作人",
          dataIndex: "admin_user_name",
        },
        {
          title: "状态",
          dataIndex: "state",
          scopedSlots: { customRender: "state" },
        },
        {
          title: "提交时间",
          dataIndex: "created",
        },
        {
          title: "调拨详情",
          dataIndex: "action",
          scopedSlots: { customRender: "action" },
        },
      ],
      stocks: [],
      // 加载数据方法 必须为 Promise 对象
      loadData: (params) => {
        return getSorderList(
          Object.assign({ ...params, type: 1 }, this.queryParam)
        ).then((res) => res);
      },
    };
  },
  created() {
    this.getBranchList();
  },
  methods: {
    getBranchList: function () {
      getBranchList().then((res) => {
        this.branches = res.list;
      });
    },
    handleSearch(e) {
      e.preventDefault();
      this.queryParam = {
        out_branch_id: this.searchForm.getFieldValue("naout_branch_idme"),
        branch_id: this.searchForm.getFieldValue("branch_id"),
        state: this.searchForm.getFieldValue("state"),
        ding_talk_order_no: this.searchForm.getFieldValue("ding_talk_order_no"),
        order_no: this.searchForm.getFieldValue("order_no"),
      };
      this.$refs.table.refresh();
    },
    handleView(row) {
      let routertwo = this.$router.resolve({
        name: "AllocationRecordDetail",
        params: { id: row.id },
      });
      window.open(routertwo.href, "_blank");
    },
  },
};
</script>
<style scoped>
.pic {
  width: 50px;
  height: 50px;
}
.pic > img {
  width: 50px;
  height: 50px;
  display: block;
}
</style>
